import { ComingSoon } from '../../components/ComingSoon';

export function SettingsPage(): React.JSX.Element {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#1E293B]">平台配置</h1>
      <ComingSoon
        title="平台配置"
        description="需要接入 /api/admin/settings 接口，配置套餐价格、AI 供应商、支付、短信等。"
      />
    </div>
  );
}
